// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsappButton_whatsappButton__h0lKA"};